import React from 'react';
import defaultValue from './default-value';

const Context = React.createContext(defaultValue);

export default Context;